import * as singleSpa from "single-spa";

singleSpa.registerApplication({
  name: "registration",
  app: () => System.import("@mfe/registration"),
  activeWhen: ["/registration"],
});

singleSpa.setBootstrapMaxTime(100000, true);
singleSpa.setMountMaxTime(100000, true);
singleSpa.setUnmountMaxTime(100000, true);
singleSpa.setUnloadMaxTime(100000, true);

singleSpa.start();
